var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
function kebabCase(str) {
    return str
        .substring(3)
        .replace(/([A-Z])/g, '-$1')
        .toLowerCase()
        .replace(/^-/, '');
}
const IconBase = React.forwardRef((props, ref) => {
    const { name = '', className, style, spin, rotate, tabIndex, onClick, children } = props, restProps = __rest(props, ["name", "className", "style", "spin", "rotate", "tabIndex", "onClick", "children"]);
    const svgStyle = {};
    if (rotate) {
        svgStyle.msTransform = `rotate(${rotate}deg)`;
        svgStyle.transform = `rotate(${rotate}deg)`;
    }
    const kebabCaseName = name ? kebabCase(name) : undefined;
    let iconTabIndex = tabIndex;
    if (iconTabIndex === undefined && onClick) {
        iconTabIndex = -1;
    }
    const attrs = Object.assign({ role: 'img', 'aria-label': kebabCaseName, focusable: 'false', 'data-icon': kebabCaseName, 'aria-hidden': 'true', preserveAspectRatio: 'xMidYMid meet', ref, tabIndex: iconTabIndex, onClick, className: [
            'rv-icon',
            kebabCaseName ? `rv-icon-${kebabCaseName}` : '',
            spin ? 'rv-icon--spin' : '',
            className,
        ]
            .join(' ')
            .trim(), style: Object.assign(Object.assign({}, style), svgStyle) }, restProps);
    return React.cloneElement(children, attrs);
});
export default IconBase;
